import { z } from "zod";

export const newsSchema = z.object({
  title: z
    .string({
      message: "Title is required",
    })
    .nonempty({
      message: "Title is required",
    }),
  content: z
    .string({
      message: "Content is required",
    })
    .nonempty({
      message: "Content is required",
    }),
  from_date: z.any().nullable().optional(),
  to_date: z.any().nullable().optional(),
  social_links_text: z.string().optional(),
  status: z.union([z.string(), z.number()]).nullable().optional(),
  image: z.any().optional(),
});

export type ZNews = z.infer<typeof newsSchema>;
